<template>
  <b-card title="مدیریت پیام ها">
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
        <b-row>
          <div class="filter-row">
            <b-button
              variant="primary"
              class="mb-1 mr-auto ml-1"
              :to="{ name: 'sendNotification'}"
            >
              جدید
            </b-button>

          <b-col md="2">
            <b-form-group
              label="عنوان"
              label-for="Title"
            >
              <b-form-input
                v-model="filterOptions.Title"
                @keyup.enter="update(1)"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              label="وضعیت"
              label-for="Status"
            >
              <v-select
                v-model="filterOptions.Status"
                dir="rtl"
                :reduce="x => x.value"
                label="text"
                :clearable="true"
                :options="enums('notificationStatus')"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              label="نوع"
              label-for="Type"
            >
              <v-select
                v-model="filterOptions.Type"
                dir="rtl"
                :reduce="x => x.value"
                label="text"
                :clearable="true"
                :options="enums('sendVia')"
              />
            </b-form-group>
          </b-col>
            <b-col md="2">
              <b-form-group
                  label="تکرار"
                  label-for="Repeat"
              >
                <v-select
                    v-model="filterOptions.Repeat"
                    dir="rtl"
                    :reduce="x => x.value"
                    label="text"
                    :clearable="true"
                    :options="enums('Repeat')"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                  label="از تاریخ"
                  label-for="StartDate"
              >
                <date-picker
                    v-model="filterOptions.FromDate"
                    clearable
                    type="date"
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jD"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                  label="تا تاریخ"
                  label-for="StartDate"
              >
                <date-picker
                    v-model="filterOptions.ToDate"
                    clearable
                    type="date"
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jD"
                />
              </b-form-group>
            </b-col>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="warning"
              @click="update(1)"
              class="mb-1 mr-1"
            >فیلتر
            </b-button>
            <b-button
                variant="gradient-secondary"
                class="mb-1 mr-1"
                @click="exportExcel()"
            >خروجی اکسل
            </b-button>
          </div>
        </b-row>
          </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
        >
          <template #cell(SendTime)="data">
            {{ data.value | date }}
          </template>

          <template #cell(IsDraft)="data">
            {{
              data.item.IsDone === true ?
                "ارسال شده" :
                data.value ?
                  'پیش نویس'
                  :
                  'در اننتظار ارسال'
            }}
          </template>
          <template #cell(Type)="data">
            {{ enums('sendVia','value',data.value,'text') }}
          </template>

          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'sendNotification', params: { messageId: data.item.Id }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Repeat)="data">
            <b-avatar :variant="data.value?'light-info':'light-warning'">
                          <feather-icon
                              v-b-tooltip.hover.top="data.value?'فعال':'غیرفعال'"
                              icon="RepeatIcon"
                              class="cursor-pointer"
                              @click="showRepeatModal(data.item)"
                          />
            </b-avatar>

          </template>

          <template #cell(Description)="data">
            <template v-for="(item, index) in data.value.split('\n')">
              <br v-if="index > 0 && item.trim()">
              {{item}}
            </template>
          </template>

          <template #cell(actions)="data">
            <div
              class="text-nowrap"
            >
              <feather-icon
                  v-if="data.item.Repeat"
                  icon="BarChartIcon"
                  size="16"
                  class="mr-1"
                  @click="showReport(data.item)"
              />

              <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  @click="showStatusModal(data.item)"
              />

              <feather-icon
                  icon="SendIcon"
                  size="16"
                  class="ml-1"
                  @click="showModal(data.item.Id)"
              />
              <b-link :to="{ name: 'sendNotification', params: { messageId: data.item.Id }}">
                <feather-icon
                  icon="EditIcon"
                  size="16"
                  class="ml-1"
                />
              </b-link>
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>
          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <b-modal
        v-model="isShow"
        title="پیام آزمایشی"
        size="sm"
        centered
        hide-footer
        :no-close-on-backdrop="true"
    >
      <b-overlay
          :show="loadingExamine"
          rounded="sm"
      >
        <b-col cols="12">
          <b-row>
            <b-col cols="5">
              <b-form-radio
                  v-model="showPush"
                  name="some-radios"
                  :value="true"
              >
                نوتیف تستی
              </b-form-radio>
            </b-col>
            <b-col cols="7">
              <b-form-radio
                  v-model="showPush"
                  name="some-radios"
                  :value="false"
              >
                نوتیف سایلنت به سگمنت
              </b-form-radio>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" class="mt-2 mb-2">
          <b-form-group
              label="شناسه کاربر"
              label-for="UserId"

          >
            <b-form-input
                v-model="userId"
                type="number"
                autocomplete="off"
                :disabled="!showPush"
            />
          </b-form-group>
        </b-col>
        <b-col class="mt-3 text-center">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              @click="examine"
          >
            ارسال
          </b-button>
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="isShow = false"
          >
            انصراف
          </b-button>
        </b-col>
      </b-overlay>
    </b-modal>

    <b-modal
        v-model="repeatModal"
        v-if="repeatModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تکرار پیام"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >
      <b-col cols="12" class="mt-2 mb-2">
          <b-form-checkbox
              v-model="row.Repeat"
              class="custom-control-info mb-2"
          >
            پیام هر روز ارسال شود
          </b-form-checkbox>

          <b-form-checkbox
              v-model="row.Duplicate"
              :disabled="!row.Repeat"
              value="false"
              class="custom-control-info"
          >
            فقط یکبار این پیام برای هر کاربر ارسال شود
          </b-form-checkbox>
      </b-col>
    </b-modal>

    <b-modal
        v-model="statusModal"
        v-if="statusModal"
        hide-footer
        centered
        title="جزئیات ارسال"
        size="sm"
    >
      <b-col cols="12" class="mt-2 mb-2">
        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-info"
              >
                <feather-icon
                    size="18"
                    icon="UserIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                تعداد کل کاربر
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.All | price }}</span>
          </div>
        </div>

        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-secondary"
              >
                <feather-icon
                    size="18"
                    icon="TrendingUpIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                در صف
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.InQueue | price}}</span>
          </div>
        </div>

        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-danger"
              >
                <feather-icon
                    size="18"
                    icon="XIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                ناموفق
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.Failed | price}}</span>
        </div>
        </div>

        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-success"
              >
                <feather-icon
                    size="18"
                    icon="CheckIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                ارسال شده
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.Successful | price}}</span>
        </div>
        </div>

        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-info"
              >
                <feather-icon
                    size="18"
                    icon="EyeIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                رسیده به کاربر
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.Delivery|price}}</span>
        </div>
        </div>

        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-primary"
              >
                <feather-icon
                    size="18"
                    icon="ExternalLinkIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                کلیک شده توسط کاربر
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.Click | price }}</span>
        </div>
        </div>

        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-danger"
              >
                <feather-icon
                    size="18"
                    icon="TrashIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                حذف اپلیکیشن توسط کاربر
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.RemovedApplication | price }}</span>
          </div>
        </div>

        <div class="notification-status">
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  variant="light-warning"
              >
                <feather-icon
                    size="18"
                    icon="AlertCircleIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="item-status-title">
                بدون توکن فایربیس
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="font-weight-700">{{ row.Status.WithoutFireBaseToken | price }}</span>
          </div>
        </div>

      </b-col>
    </b-modal>

    <b-modal
        v-model="showRemoveModal"
        title="حذف"
        size="sm"
        centered
        hide-footer
        modal-class="modal-danger"
        :no-close-on-backdrop="true"
    >
      <b-overlay
          :show="loadingRemove"
          rounded="sm"
      >
        <span>آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟</span>
        <b-col class="mt-3 text-center">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="danger"
              class="mr-1"
              @click="confirmRemove"
          >
            تایید
          </b-button>
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="showRemoveModal = false"
          >
            انصراف
          </b-button>
        </b-col>
      </b-overlay>
    </b-modal>

    <notification-report :show.sync="showReportModal" :report="row && row.Report" />
  </b-card>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'
import NotificationReport from "./notificationReport.vue";

export default {
  name: 'Notification',
  components: {
    VueApexCharts,
    NotificationReport,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      filterOptions: {
        Page: 1,
        Title: null,
        PerPage: 10,
        Type: null,
        IsDraft: null,
        IsDone: false,
        Status: null,
        Repeat: null,
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'IsDraft',
          label: 'وضعیت',
        },
        {
          key: 'SendTime',
          label: 'تاریخ',
        },
        {
          key: 'Description',
          label: 'متن',
        },
        {
          key: 'Type',
          label: 'نوع',
        },
        {
          key: 'Repeat',
          label: 'تکرار',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      loading: false,
      id: null,
      userId: null,
      isShow: false,
      repeatModal: false,
      row: null,
      statusModal: false,
      loadingExamine: false,
      loadingRemove: false,
      showRemoveModal: false,
      showReportModal: false,
      showPush: true,
      processing: false,
      counter: 1
    }
  },
  watch: {
    showPush(val) {
      if (!val) this.userId = null
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      if (this.filterOptions.Status === 'draft') {
        this.filterOptions.IsDone = null
        this.filterOptions.IsDraft = true
      } else if (this.filterOptions.Status === 'waitToSent') {
        this.filterOptions.IsDone = false
        this.filterOptions.IsDraft = false
      } else if (this.filterOptions.Status === null) {
        this.filterOptions.IsDone = null
        this.filterOptions.IsDraft = null
      } else if (this.filterOptions.Status === 'done') {
        this.filterOptions.IsDone = true
        this.filterOptions.IsDraft = null
      }
      this.$http.post(
        this.$api.declarations.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.id = id
      this.showRemoveModal = true
    },
    confirmRemove() {
      this.loadingRemove = true
      this.$http.post(
          this.$api.declarations.remove, { Id: this.id },
      )
          .then(() => {
            this.showRemoveModal = false
            this.loadingRemove = false
          }).catch(() => {
        this.loadingRemove = false
        this.showRemoveModal = false
      })
    },
    showModal(id){
      this.userId = null
      this.id = id
      this.isShow = true
    },
    examine() {
      this.loadingExamine = true
      let data = {
        Id: this.id,
        UserId: this.showPush ? this.userId : 1,
        ShowPush: this.showPush
      }

      this.$http.post(
          this.$api.declarations.examine, data,
      )
          .then(() => {
            this.isShow = false
            this.loadingExamine = false
            this.id = null
          }).catch(() => {
        this.loadingExamine = false
      })
    },
    showRepeatModal(row){
      this.row = JSON.parse(JSON.stringify(row))
      this.repeatModal = true
    },
    showStatusModal(row){
      this.row = row
      this.statusModal = true
    },
    save(){
      this.$http.post(
          this.$api.declarations.recurring, this.row,
      )
          .then(res => {
            this.update()
            this.repeatModal = false
          })
    },
    showReport(row) {
      this.row = row
      this.showReportModal = true
    },
    exportExcel(){
      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'notifications.xls'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      xmlHttpRequest.open("POST", '/api/notification/excel')
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify(this.filterOptions))
    }
  }
}
</script>

<style scoped>
.notification-status{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
 .item-status-title {
  margin-bottom: 0px;
  color: #6e6b7b;
}
 .font-weight-700{
   font-weight: 600;
   color: #5e5873;
 }
</style>
